import { InvitePatient } from 'domain/usecases/patient/invite-patient'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteInvitePatient implements InvitePatient {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  update(params: InvitePatient.Params): Promise<InvitePatient.Model> {
    return this.patientRepository.invitePatient(params)
  }
}

export type InvitePatientModel = InvitePatient.Model
